<template>
    <div class="Course">
        <!--<b-button @click="TrainingReport()">Training Report</b-button>-->
        <h2>Courses <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /></h2>
        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Level:</label>
                        <select class="form-control" v-model="Filters.Level" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option value="Initial">Initial</option>
                            <option value="Refresher">Refresher</option>
                            <option value="Repeating">Repeating</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Region:</label>
                        <select class="form-control" v-model="Filters.Region" @change="RefreshDataTable">
                            <option v-if="CheckPermission('CanAccessAllOptionInSubPrograms')" value="All">All</option>
                            <option v-for="region in UserPrivateProfile.Region" v-if="region != null" v-bind:value="region">{{ region }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Category:</label>
                        <select class="form-control" v-model="Filters.Category" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option v-for="category in CategoryList" v-bind:value="category">{{ category }}</option>
                        </select>
                    </div>
                </div>
                <!--<div class="col-sm-4">
        <div class="form-group">
            <label>Expires In (Months):</label>
            <b-form-input v-model="Filters.ExpirationDate"  @input="RefreshDataTable" type="number">
        </div>
    </div>-->
            </div>
            <div class="row">
                <div class="col-sm-4"></div>
                <div class="col-sm-4"></div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Courses:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    Displaying {{NumberOfClients}} Records
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <b-button @click="OpenAddCourseModal()" variant="olive-green" style="margin-bottom:1rem;"> Add Course</b-button>
                </div>
            </div>
        </form>
        <div style="overflow-x:auto;">
            <vuetable :fields="CourseTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable"
                      id="childrendatatableid">
                <template slot="CourseActions" scope="props">
                    <div class="CourseActionsDiv">
                        <b-row no-gutters>
                            <b-col md="auto">
                                <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 20px; margin-right:0.5rem;" class="pointer orange " @click="UpdateCourseModal(props.rowData)" />
                                <ActionButtonWithIcon :requires-confirmation="true"
                                          :confirmation-string="DeletionWarning"
                                          endpoint="Training/DeleteCourse"
                                          :payload="{Id: props.rowData.Id}"
                                          :perform-global-update="false"
                                          button-variant="success"
                                          button-string=""
                                          button-size="md"
                                          emit-on-success="role-deleted"
                                          v-on:success="RefreshDataTable"
                                          icon-prefix="fa"
                                          icon-suffix="trash-alt"
                                          icon-color="red"
                                          method="POST"/>
                            </b-col>
                        </b-row>
                    </div>
                </template>
            </vuetable>
        </div>
        <b-modal @show="ClearCourseForm()" @hide="ClearCourseForm()" ref="add-course-modal" title="Add Course" hide-footer>
            <b-container fluid>
                <b-form @submit="AddCourse">
                    <b-row>
                        <b-col cols="12"><b>Name:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="CourseForm.Name" type="name" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Category:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="CourseForm.Category" type="name" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Level:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="CourseForm.Level" required>
                                <option value="Initial">Initial</option>
                                <option value="Refresher">Refresher</option>
                                <option value="Repeating">Repeating</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Description:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea cols="4" v-model="CourseForm.Description" type="name" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Region:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="CourseForm.Region">
                                <option v-for="region in UserPrivateProfile.Region" v-if="region != null" v-bind:value="region">{{ region }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Duration (minutes):</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="CourseForm.Duration" type="number" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Expires In (Months):</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="CourseForm.ExpirationDate" type="number"></b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelModal('add-course-modal')">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <b-modal ref="edit-course-modal" title="Edit Course" hide-footer>
            <b-container fluid>
                <b-form @submit="UpdateCourse">
                    <b-row>
                        <b-col cols="12"><b>Name:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="UpdateCourseForm.Name" type="name" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Category:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="UpdateCourseForm.Category" type="name" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Level:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="UpdateCourseForm.Level" required>
                                <option value="Initial">Initial</option>
                                <option value="Refresher">Refresher</option>
                                <option value="Repeating">Repeating</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Description:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea cols="4" v-model="UpdateCourseForm.Description" type="name" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Region:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="UpdateCourseForm.Region">
                                <option v-for="region in UserPrivateProfile.Region" v-if="region != null" v-bind:value="region">{{ region }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Duration (minutes):</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="UpdateCourseForm.Duration" type="number" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Expires In (Months):</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="UpdateCourseForm.ExpirationDate" type="number"></b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelModal('edit-course-modal')">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
    //import services
    //import { ClientsAPI } from '../../../services/api/Foster/ClientsAPI.js';

    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faCaretDown);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { EventBus } from '../../services/event-bus.js';
    export default {
        created() {
            //this.$store.commit("Clients.ClientProfiles.Clear");
            //this.$store.commit("Clients.ClientEnrollmentsList.Clear");
            //const clientsAPI = new ClientsAPI(this.$baseURL);
            //this.clientsAPI = clientsAPI;
        },
        props: [],
        data: function () {
            return {
                NumberOfClients: '',
                DeletionWarning: "<h2>WARNING: <h2> <br /> <h3>You are about to delete this course. All related sessions will also be deleted. This can not be undone. <b>You have been warned.</b></h3>",
                search: "",
                CourseList: [],
                CategoryList: [],
                CourseForm: {
                    //Id:'',
                    Duration: '',
                    Region: '',
                    Description: '',
                    Name: '',
                    Level: '',
                    ExpirationDate: '',
                    Category: '',
                },
                UpdateCourseForm: {
                    Id:'',
                    Duration: '',
                    Region: '',
                    Description: '',
                    Name: '',
                    Level: '',
                    ExpirationDate: '',
                    Category: '',
                },
                Filters: {
                    Level: "All",
                    Region: "All",
                    ExpirationDate: null,
                    Category: "All"
                },
                CourseTableOptions: {
                    Fields: [
                       {
                           name: 'Name',
                           title: 'Name',
                           sortField: 'Name'
                       },
                       {
                           name: 'Categories.Name',
                           title: 'Category',
                           sortField: 'Categories.Name'
                       },
                       {
                            name: 'Description',
                            title: 'Description',
                            sortField: 'Description'
                        },
                        {
                            name: 'Level',
                            title: 'Level',
                            sortField: 'Level'
                        },
                        {
                            name: 'Region',
                            title: 'Region',
                            sortField: 'Region'
                        },
                        {
                            name: 'Duration',
                            title: 'Duration',
                            sortField: 'Duration'
                         },
                        {
                            name: 'ExpirationDate',
                            title: 'Expires In (Months)',
                            sortField: 'ExpirationDate',
                        },
                        //{
                        //    name: 'ReferredByName',
                        //    title: 'Referred By',
                        //    sortField: 'ReferredByName'
                        //},
                        //{
                        //    name: 'Comments',
                        //    title: 'Comments',
                        //    sortField: 'Comments'
                        //},
                        {
                            name: '__slot:CourseActions',
                            title: 'Actions'
                         },
                        //{
                        //    name: '__slot:Enroll',
                        //    title: 'Enroll'
                        //}
                    ]
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false,
                },
            };
        },
        methods: {
            TrainingReport() {
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetEmployeesInTraining", { StartDate: new Date(2020, 7, 1), EndDate: new Date(2020, 12, 1)}, this.TrainingReportSuccess, () => { }, true);
            },
            TrainingReportSuccess(response) {
                let a = document.createElement("a") 
                let blobURL = URL.createObjectURL(response.data)
                a.download = response.headers["content-disposition"].split('=')[1];
                a.href = blobURL
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            },
            RefreshDataTable() {
                this.GetCourses();

            },
            AddCourse(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Training/AddCourse", this.CourseForm, this.AddCourseSuccess, () => { }, true);
            },
            AddCourseSuccess(response) {
                this.GetCourses();
                this.$refs["add-course-modal"].hide();
            },
            GetCourses() {
                //this.AdditionalPayload.DisplayPin = this.DisplayPin;
                //loop through Panes shown and flip true/false values
                this.CategoryList = [];
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetCourses", this.Filters, this.GetCoursesSucceess, () => { }, true);
            },
            GetCoursesSucceess(response) {
                this.CourseList = response.data.data;
                let vm = this;
                vm.CourseList.forEach(function (course) {
                    if (!vm.CategoryList.includes(course.Categories.Name)) {
                        vm.CategoryList.push(course.Categories.Name);
                    }
                });
                vm.$refs.datatable.refresh();
            },
            UpdateCourse(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Training/UpdateCourse", this.UpdateCourseForm, this.UpdateCourseSuccess, () => { }, true);
            },
            UpdateCourseSuccess(response) {
                this.GetCourses();
                this.$refs["edit-course-modal"].hide();
            },
            UpdateCourseModal(rowData) {
                this.UpdateCourseForm.Id = rowData.Id;
                this.UpdateCourseForm.Duration = rowData.Duration;
                this.UpdateCourseForm.Region = rowData.Region;
                this.UpdateCourseForm.Description= rowData.Description;
                this.UpdateCourseForm.Name = rowData.Name;
                this.UpdateCourseForm.Level = rowData.Level;
                this.UpdateCourseForm.ExpirationDate = rowData.ExpirationDate;
                this.UpdateCourseForm.Category = rowData.Categories.Name;
                this.$refs["edit-course-modal"].show();
                
            },
            ClearCourseForm() {
                this.CourseForm.Duration = "";
                this.CourseForm.Region = "";
                this.CourseForm.Description= "";
                this.CourseForm.Name = "";
                this.CourseForm.Level = "";
                this.CourseForm.ExpirationDate = "";
                this.CourseForm.Category = "";
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.CourseList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfClients = visibleData.length;
                return visibleData;
            },
            OpenAddCourseModal() {
                this.$refs["add-course-modal"].show();
            },
            CancelModal(modalRef) {
                this.$refs[modalRef].hide();
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            Vuetable,
            flatPickr,
            ActionButtonWithIcon
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            UserPrivateProfile: function () {
                this.Filters.Region = this.$store.state.User.PrivateProfile.Permissions.includes("Administrator") ? "All" : this.$store.state.User.PrivateProfile.Region[0];
                return this.$store.state.User.PrivateProfile;
            },
        },
        mounted() {
            this.GetCourses();
            //this.Filters.SubProgramID = this.SubProgramOptions[0].value;
            //var vm = this;
            ////Get Child Records*/
            //this.GetChildren();
            //let getchildrenFunc = function () {
            //    vm.GetChildren();
            //};
            //this.$GlobalUpdate.AddGlobalUpdateFunction(getchildrenFunc);
        }
    }
</script>

<style scoped>
    .btn-olive-green {
        background-color: #94A545 !important;
        color: white;
        box-shadow:none;
    }
</style>